module.exports = "../images/fishing-lodge-3-16.jpg?v=d8ed6d9";